















































































































































































































































































































































































































































































import {
  dateFormat,
  dateTransactionFormat,
  datePickerFormat,
} from '@/constants';

import { OpenHelp } from '@/mixins';
import {
  OpenAttachDocumentsScreen,
  OpenAddClaimNoteScreen,
  OpenViewAttachmentScreen,
  OpenEOPOverlayScreen,
} from '@/mixins/get-content-mixins';
import { ExtendMixins } from '@/services';
import {
  PendingTransactionResponseModel,
  PostedTransactionResponseModel,
} from '@/@types/member';

interface Data {
  dateTransactionFormat: string;
  datePickerFormat: string;
}

export default ExtendMixins(
  OpenHelp,
  OpenAttachDocumentsScreen,
  OpenAddClaimNoteScreen,
  OpenViewAttachmentScreen,
  OpenEOPOverlayScreen,
).extend({
  name: 'TransactionDetail',
  props: {
    transaction: {
      type: Object as () => PostedTransactionResponseModel | PendingTransactionResponseModel,
      required: true,
    },
    hideActions: {
      type: Boolean,
      default: false,
    },
    isEvaultMatch: {
      type: Boolean,
      default: false,
    },
    dateFormat: {
      type: String,
      default: dateFormat,
    },
  },
  data(): Data {
    return {
      dateTransactionFormat,
      datePickerFormat,
    };
  },
  computed: {
    hasNote(): string {
      // This can also be pending transaction but just shutting up ts lint since it is ok to return undefined
      return (this.transaction as PostedTransactionResponseModel).noteToSelf;
    },
    attachments(): any[] {
      const attachments = (this.transaction as PostedTransactionResponseModel).attachments;
      // tslint:disable-next-line
      if (!attachments || attachments.length == 0) { return attachments; }
      return attachments.sort((a, b) => {
        return a.fileName.localeCompare(b.fileName);
      });
    },
  },
});
